/* NEOKULT theme scripts */
(function(){
  'use strict';
  var money = function(cents){
    var cur = (window.NEOKULT && window.NEOKULT.currency) || 'CHF';
    return cur + ' ' + (cents/100).toFixed(2);
  };

  /* ---- cart count refresh ---- */
  function refreshCart(cb){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count;});
        updateGift(cart.total_price);
        if(cb) cb(cart);
      }).catch(function(){});
  }

  /* ---- gratis-sticker progress ---- */
  function updateGift(totalCents){
    var el = document.querySelector('[data-gift]');
    if(!el) return;
    var threshold = parseInt(el.getAttribute('data-threshold'),10) || 6500;
    var bar = el.querySelector('.bar span');
    var label = el.querySelector('[data-gift-label]');
    var pct = Math.min(100, Math.round((totalCents/threshold)*100));
    if(bar) bar.style.width = pct + '%';
    if(totalCents >= threshold){
      el.classList.add('reached');
      if(label) label.innerHTML = 'Gratis-Sticker freigeschaltet';
    } else {
      el.classList.remove('reached');
      if(label) label.innerHTML = 'Noch <b>'+money(threshold-totalCents)+'</b> bis zum Gratis-Sticker';
    }
  }

  /* ---- product form ---- */
  function initProductForm(root){
    var dataEl = root.querySelector('[data-variants]');
    if(!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var atc = root.querySelector('[data-atc]');
    var priceEl = root.querySelector('[data-price]');
    var scarce = root.querySelector('[data-scarce]');
    var stickySize = document.querySelector('[data-sticky-size]');
    var main = root.querySelector('[data-main-image]');
    var selected = {};

    /* Seed JS state from the server-rendered selection.
       Liquid marks the current variant's option buttons with aria-pressed="true";
       without this the buttons LOOK selected while `selected` stays empty,
       so findVariant() never matches and the ATC button stays dead. */
    root.querySelectorAll('[data-option]').forEach(function(group){
      var name = group.getAttribute('data-option');
      var available = group.querySelectorAll('[data-value]:not([disabled])');
      var pressed = group.querySelector('[data-value][aria-pressed="true"]:not([disabled])');
      /* Grösse nie automatisch vorwählen, ausser es gibt nur eine */
      var needsPick = group.hasAttribute('data-needs-selection') && available.length > 1;
      var pick = pressed || (needsPick ? null : available[0]);
      if(!pick){
        group.querySelectorAll('[data-value]').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
        return;
      }
      group.querySelectorAll('[data-value]').forEach(function(b){
        b.setAttribute('aria-pressed', b === pick ? 'true' : 'false');
      });
      selected[name] = pick.getAttribute('data-value');
      var nameLabel = group.parentNode.querySelector('[data-option-current]');
      if(nameLabel) nameLabel.textContent = selected[name];
    });

    function findVariant(){
      return variants.find(function(v){
        return v.options.every(function(opt,i){
          var name = root.getAttribute('data-opt'+(i+1)) || ('option'+(i+1));
          return selected[name] === undefined || selected[name] === opt;
        }) && Object.keys(selected).length === v.options.length;
      });
    }

    /* Swap the main image + matching thumbnail to the selected variant's
       assigned image (product.variants[].featured_image in Shopify). If the
       variant has no image of its own (e.g. size-only variants), the image
       stays as-is. */
    function applyVariantImage(v){
      if(!main || !v || !v.featured_image || !v.featured_image.src) return;
      var base = v.featured_image.src;
      var sized = base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=1100';
      if(main.getAttribute('data-current-src') === base) return;
      main.src = sized;
      main.setAttribute('data-current-src', base);

      var thumbs = root.querySelectorAll('[data-thumb]');
      var matched = false;
      thumbs.forEach(function(t){
        var tSrc = (t.getAttribute('data-src') || '').split('?')[0];
        var isMatch = tSrc && base.indexOf(tSrc) > -1;
        t.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        if(isMatch) matched = true;
      });
      if(!matched){
        thumbs.forEach(function(t){ t.setAttribute('aria-selected','false'); });
      }
    }

    function apply(){
      var v = findVariant();
      if(!v){
        atc.setAttribute('disabled','');
        atc.textContent = 'Grösse wählen';
        return;
      }
      idInput.value = v.id;
      applyVariantImage(v);
      if(priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price>v.price ? ' <span class="compare">'+money(v.compare_at_price)+'</span>' : '');
      if(v.available){
        atc.removeAttribute('disabled');
        atc.innerHTML = 'In den Warenkorb <span class="amt">· '+money(v.price)+'</span>';
      } else {
        atc.setAttribute('disabled','');
        atc.textContent = 'Ausverkauft';
      }
      if(scarce){
        if(v.available && typeof v.inventory_quantity === 'number' && v.inventory_management && v.inventory_quantity>0 && v.inventory_quantity<=8){
          scarce.innerHTML = '<i></i> Nur noch '+v.inventory_quantity+' Stück verfügbar';
        } else { scarce.innerHTML=''; }
      }
      if(stickySize){
        var sizeName = root.getAttribute('data-opt-size');
        stickySize.textContent = sizeName && selected[sizeName] ? selected[sizeName] : (v.title !== 'Default Title' ? v.title : '');
      }
    }

    root.querySelectorAll('[data-option]').forEach(function(group){
      var name = group.getAttribute('data-option');
      group.querySelectorAll('[data-value]').forEach(function(btn){
        if(btn.hasAttribute('disabled')) return;
        btn.addEventListener('click',function(){
          group.querySelectorAll('[data-value]').forEach(function(b){b.setAttribute('aria-pressed','false');});
          btn.setAttribute('aria-pressed','true');
          selected[name] = btn.getAttribute('data-value');
          var nameLabel = group.parentNode.querySelector('[data-option-current]');
          if(nameLabel) nameLabel.textContent = selected[name];
          apply();
        });
      });
    });

    apply();

    // add to cart (AJAX)
    var form = root.querySelector('form[action$="/cart/add"]');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(atc.hasAttribute('disabled')){
        var sizes = root.querySelector('[data-needs-selection]');
        if(sizes){ sizes.classList.add('shake'); setTimeout(function(){sizes.classList.remove('shake');},300); }
        if(scarce) scarce.innerHTML = '<i></i> Bitte zuerst Grösse und Farbe wählen';
        return;
      }
      var body = new FormData(form);
      atc.textContent = 'Wird hinzugefügt...';
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:body})
        .then(function(r){return r.json();})
        .then(function(){
          atc.classList.add('added');
          atc.innerHTML = 'Hinzugefügt ✓';
          refreshCart();
          setTimeout(function(){atc.classList.remove('added');apply();},1600);
        }).catch(function(){ atc.textContent='Fehler, bitte erneut'; });
    });

    // sticky button mirrors main ATC
    var stickyBtn = document.querySelector('[data-sticky-atc]');
    if(stickyBtn){
      stickyBtn.addEventListener('click',function(){
        atc.scrollIntoView({behavior:'smooth',block:'center'});
        setTimeout(function(){ form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit',{cancelable:true})); },420);
      });
    }

    // gallery thumbs
    root.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        root.querySelectorAll('[data-thumb]').forEach(function(x){x.setAttribute('aria-selected','false');});
        t.setAttribute('aria-selected','true');
        var src = t.getAttribute('data-src');
        if(main && src){
          main.src = src;
          main.setAttribute('data-current-src', src.split('?')[0]);
        }
      });
    });
  }

  /* ---- sticky bar visibility ---- */
  function initSticky(){
    var sticky = document.querySelector('.sticky');
    if(!sticky) return;
    window.addEventListener('scroll',function(){
      var y = window.scrollY;
      var max = document.body.scrollHeight - 1400;
      sticky.classList.toggle('on', y>620 && y<max);
    },{passive:true});
  }

  /* ---- cart line qty/remove (AJAX) on cart page ---- */
  function initCart(){
    document.querySelectorAll('[data-change]').forEach(function(a){
      a.addEventListener('click',function(e){
        e.preventDefault();
        var line = a.getAttribute('data-line');
        var qty = parseInt(a.getAttribute('data-change'),10);
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({line:parseInt(line,10),quantity:qty})})
          .then(function(r){return r.json();})
          .then(function(){ window.location.reload(); });
      });
    });
  }

  /* ---- reveal ---- */
  function initReveal(){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.14});
    document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
  }

  /* ---- product recommendations ---- */
  function initRecommendations(){
    var el = document.querySelector('[data-recommendations]');
    if(!el) return;
    if(el.children.length > 0) return;
    var url = el.getAttribute('data-url');
    if(!url) return;
    fetch(url).then(function(r){return r.text();}).then(function(html){
      var doc = new DOMParser().parseFromString(html,'text/html');
      var grid = doc.querySelector('[data-recommendations]');
      if(grid && grid.innerHTML.trim()){
        el.innerHTML = grid.innerHTML;
        initReveal();
      } else {
        el.closest('.band').style.display = 'none';
      }
    }).catch(function(){});
  }

  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('[data-product-root]').forEach(initProductForm);
    initSticky(); initCart(); initReveal(); initRecommendations();
    refreshCart();
  });
})();
